import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { STAFF } from "../config/staffConfig";

/**
 * StaffPicker — reusable staff dropdown (hotfix/conflict-check-inline-self-approval).
 *
 * Single source of truth for "pick a member of staff" dropdowns. Options are
 * derived from the unified STAFF config (staffConfig.js) so the list can never
 * drift from the canonical roster. The selected VALUE is the staff full_name,
 * matching the existing Fee Earner / Decision Maker selects in ConflictCheck.jsx
 * (which also key on full_name).
 *
 * Props:
 *   value          — currently selected full_name (controlled)
 *   onChange       — (fullName: string) => void
 *   filter         — optional predicate (staff) => bool to restrict the list.
 *                    Defaults to active staff only.
 *   placeholder    — trigger placeholder text
 *   disabled       — disable the control
 *   testId         — data-testid for the trigger (test hooks)
 *   className      — extra classes for the trigger
 *   showInitials   — append "(INITIALS)" to each option label (default true)
 */
export default function StaffPicker({
  value,
  onChange,
  filter,
  placeholder = "Select staff member",
  disabled = false,
  testId,
  className = "border-navy-border",
  showInitials = true,
}) {
  const predicate = filter || ((s) => s.is_active);
  const options = STAFF.filter(predicate);

  return (
    <Select value={value || ""} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className={className} data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((s) => (
          <SelectItem key={s.email} value={s.full_name}>
            {showInitials ? `${s.full_name} (${s.initials})` : s.full_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
